import MuiTab, { TabProps } from '@mui/material/Tab'

const Tab = (props: TabProps) => {
  return (
    <MuiTab
      {...props}
      sx={{
        typography: 'h7Str',
        textTransform: 'none',
        padding: '12px 16px',
        minHeight: '40px',
        ...props.sx,
        '&.Mui-selected': {
          backgroundColor: 'primary.50',
          ...props.sx?.['&.Mui-selected'],
        },
      }}
    />
  )
}

export default Tab
